export const getUnderlineStyles = overrides => {
  return {
    '::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '100%',
      height: '2px',
      width: '100%',
      backgroundColor: 'text',
      transformOrigin: ' center top',
      transform: 'scale(0, 1)',
      transition: 'color 0.1s, transform 0.2s ease-out',
      ...overrides,
    },
    ':active::before': {
      backgroundColor: 'text',
    },

    ':hover::before': {
      transformOrigin: 'center top',

      transform: 'scale(1, 1)',
    },
    ':focus::before': {
      transformOrigin: 'center top',

      transform: 'scale(1, 1)',
    },
  }
}

const theme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body:
      '"Avenir", Helvetica, Arial, sans-serifsystem-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    heading:
      '"Avenir", Helvetica, Arial, sans-serifsystem-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    monospace:
      '"Avenir", Helvetica, Arial, sans-serifsystem-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    alternative:
      '"AvenirLTStd-Heavy", "Avenir", Helvetica, Arial, sans-serifsystem-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  },
  shadows: {
    nav: '0px 1px 2px rgba(0, 0, 0, 0.1)',
    navBottomShadow: 'rgba(0, 0, 0, 0.027) 0px 4px 4px 0px',
    default: '1px 2px 5px 0 rgba(200,200,200,0.5)',
  },
  borders: {
    default: '1px solid lightGray',
    defaultInput: '2px solid lightGray',
    mobileNavLinkBorder: '1px solid #3B3A38',
    commentBorder: '1px solid #D1CDC5',
    green: '1px solid #1DB954',
    optionBorder: '1px solid #ADAAA3',
  },
  breakpoints: ['520px', '768px', '800px', '1000px', '1120px'],
  responsive: {
    small: 768,
    medium: 800,
    mediumLarge: 1000,
    large: 1120,
  },
  zIndex: [1, 10, 20, 100, 1000, 1030, 2147483643],
  sizes: {
    pageMaxWidth: '1700px',
    maxWidth: '1050px',
    maxWidthCentered: '650px',
    navHeight: 75,
    mobileNavHeight: 62,
    mobileAccessibilityHeight: 30,
    promotionalAlertHeight: 40,
    navSubMenuHeight: 40,
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
  fontWeights: {
    body: 400,
    heading: 300,
    semiBold: 600,
    bold: 900,
  },
  lineHeights: {
    0: '20px',
    1: '24px',
    2: '32px',
    3: '48px',
    4: '56px',
    5: '64px',
  },
  colors: {
    text: '#000',
    gray: '#4A4945',
    lightGray: '#F1EFEA',
    lighterGray: '#f1efea',
    lightestGray: '#FBFBFA',
    background: '#fff',
    primary: '#C4C4C4',
    secondary: '#1DB954',
    muted: '#f6f6f6',
    red: '#a40000',
    body: '#3B3A38',
    alert: '#FFFFFF',
    success: '#71C26E',
    danger: '#971D13',
    tag: '#EAE7E0',
    green: '#1DB954',
    compareAtPrice: 'text',
    black: '#000',
    darkRed: '#971D13',
    white: '#FFFFFF',
    gold: '#E9D396',
  },
  styles: {
    root: {
      fontFamily: 'body',
      lineHeight: 'body',
      fontWeight: 'body',
      blockquote: {
        fontStyle: 'italic',
      },

      h1: {
        color: 'text',
        fontFamily: 'heading',
        lineHeight: 5,
        fontWeight: 'body',
        fontSize: [6, 7, 7, 8],
        letterSpacing: '0.12em',
      },
      h2: {
        color: 'text',
        fontFamily: 'heading',
        lineHeight: 4,
        fontWeight: 'heading',
        fontSize: 7,
        letterSpacing: '0.12em',
      },
      h3: {
        color: 'text',
        fontFamily: 'heading',
        lineHeight: 3,
        fontWeight: 'heading',
        fontSize: [5, 5, 42],
        letterSpacing: '0.12em',
      },
      h4: {
        color: 'text',
        fontFamily: 'heading',
        lineHeight: 2,
        fontWeight: 'heading',
        fontSize: [4, 4, 5],
        letterSpacing: '0.12em',
      },
      h5: {
        color: 'text',
        fontFamily: 'heading',
        lineHeight: 1,
        fontWeight: 'heading',
        fontSize: [3, 3, 4],
        letterSpacing: ['0.05em', '0.12em', '0.12em'],
      },
      h6: {
        color: 'text',
        fontFamily: 'heading',
        lineHeight: 0,
        fontWeight: 'heading',
        fontSize: 1,
        letterSpacing: ['0.05em', '0.12em', '0.12em'],
      },
      producttitle: {
        color: 'text',
        fontFamily: 'heading',
        lineHeight: '20px',
        fontWeight: 400,
        fontSize: [2, 3, 3],
        letterSpacing: ['0.05em', '0.12em', '0.12em'],
      },
      body: {
        color: 'body',
        fontFamily: 'body',
        lineHeight: 1,
        fontWeight: 'bold',
        fontSize: 2,
        letterSpacing: '4px',
      },
      p: {
        color: 'body',
        fontFamily: 'body',
        fontSize: 4,
        lineHeight: 3,
        letterSpacing: '4px',
      },
      a: {
        color: 'text',
        letterSpacing: '4px',
        textDecoration: 'none',
      },
      pre: {
        fontFamily: 'monospace',
        overflowX: 'auto',
        code: {
          color: 'inherit',
        },
      },
      code: {
        fontFamily: 'monospace',
        fontSize: 'inherit',
      },
      table: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
      },
      th: {
        textAlign: 'left',
        borderBottomStyle: 'solid',
      },
      td: {
        textAlign: 'left',
        borderBottomStyle: 'solid',
      },
    },
    hr: {
      border: '1px solid lightGray',
    },
    navlink: {
      fontSize: 0,
      fontWeight: 500,
      textTransform: 'uppercase',
      textDecoration: 'none',
      p: 2,
      px: 3,
      position: 'relative',
      cursor: 'pointer',
      ...getUnderlineStyles({ marginLeft: -16, top: '121%' }),
    },
  },
  buttons: {
    'increase-decrease': {
      bg: 'transparent',
      color: 'text',
      cursor: 'pointer',
      px: 1,
    },
    icon: {
      cursor: 'pointer',
    },
    link: {
      color: 'text',
      fontWeight: 'bold',
      fontHeight: 2,
      lineHeight: 2,
      letterSpacing: '4px',
      textDecoration: 'underline',
      bg: 'transparent',
      height: 'auto !important',
      width: 'auto !important',
      padding: 0,
    },
    whiteLink: {
      color: 'white',
      fontWeight: 'bold',
      fontHeight: 2,
      lineHeight: 2,
      letterSpacing: '4px',
      textDecorationLine: 'underline',
      bg: 'transparent',
      height: 'auto !important',
      width: 'auto !important',
      padding: 0,
    },
    close: {
      width: '20px',
      height: '20px',
      color: 'background',
    },
    primary: {
      borderRadius: 0,
      color: 'background',
      bg: 'primary',
      p: ['8px', '8px, 100px'],
      '&:hover': {
        bg: 'text',
      },
      '&:disabled': {
        bg: 'gray',
        color: 'white',
      },
    },
    secondary: {
      borderRadius: 0,
      color: 'background',
      bg: 'secondary',
      p: ['8px', '8px, 16px'],
      '&:disabled': {
        color: 'background',
        bg: '#D1CDC5',
        border: 'none',
      },
    },

    black: {
      borderRadius: 0,
      color: 'background',
      bg: 'text',
      height: '64px',
      cursor: 'pointer',
      p: ['8px', '8px, 16px'],
      '&:disabled': {
        bg: 'gray',
        color: 'white',
      },
    },
    default: {
      borderRadius: 0,
      color: 'background',
      bg: 'text',
      height: '64px',
      cursor: 'pointer',
      p: ['8px', '8px, 16px'],
      '&:disabled': {
        bg: 'gray',
        color: 'white',
      },
    },
    white: {
      borderRadius: 0,
      bg: 'background',
      color: 'text',
      cursor: 'pointer',
      p: ['8px', '8px, 16px'],
      '&:hover': {
        color: 'gray',
        bg: 'background',
      },
      '&:disabled': {
        color: 'background',
        bg: '#D1CDC5',
      },
    },
    whiteSecondary: {
      borderRadius: 0,
      bg: 'white',
      color: 'text',
      border: '2px solid white',
      cursor: 'pointer',
      p: ['8px', '8px, 16px'],
      '&:hover': {
        color: 'white',
        bg: 'black',
      },
    },

    whiteOutline: {
      borderRadius: 0,
      bg: 'transparent',
      color: 'white',
      cursor: 'pointer',
      border: '2px solid white',
      p: ['8px', '8px, 16px'],
      '&:disabled': {
        color: 'background',
        bg: '#D1CDC5',
      },
    },

    blackOutline: {
      borderRadius: 0,
      bg: 'transparent',
      color: 'black',
      cursor: 'pointer',
      border: '2px solid black',
      p: ['8px', '8px, 16px'],
      '&:disabled': {
        color: 'background',
        bg: '#D1CDC5',
      },
    },
    readMore: {
      borderRadius: 0,
      width: '248px',
      height: '32px',
      bg: 'black',
      fontSize: 2,
      fontHeight: 3,
      fontWeight: '900',
    },
  },

  text: {
    bold: {
      fontWeight: 'bold',
    },
    semiBold: {
      fontWeight: 'semiBold',
    },
    largeParagraph: {
      color: 'body',
      fontFamily: 'body',
      fontSize: 4,
      lineHeight: 3,
      letterSpacing: '4px',
    },
    body1: {
      color: 'body',
      fontFamily: 'body',
      lineHeight: 1,
      fontWeight: 'bold',
      fontSize: 2,
      letterSpacing: '1.5px',
    },
    body1semibold: {
      color: 'body',
      fontFamily: 'body',
      lineHeight: 1,
      fontWeight: 'semiBold',
      fontSize: 2,
      letterSpacing: '1.5px',
    },
    body2: {
      color: 'body',
      fontFamily: 'body',
      lineHeight: 1,
      fontSize: [0, 1, 2],
      fontWeight: 'body',
    },
    body2bold: {
      color: 'text',
      fontFamily: 'body',
      lineHeight: 1,
      fontSize: [0, 1, 2],
      fontWeight: '800',
    },
    body2semibold: {
      color: 'text',
      fontFamily: 'body',
      lineHeight: 1,
      fontSize: [0, 1, 2],
      fontWeight: 'semiBold',
      letterSpacing: '2px',
    },
    body3: {
      color: 'body',
      fontFamily: 'body',
      lineHeight: '16px',
      fontWeight: 'bold',
      fontSize: 0,
      letterSpacing: '2px',
    },
    body3semibold: {
      color: 'body',
      fontFamily: 'body',
      lineHeight: '16px',
      fontSize: 0,
      letterSpacing: '2px',
      fontWeight: 'semiBold',
    },
    navMobileLink: {
      color: 'text',
      lineHeight: 1,
      fontSize: 21,

      letterSpacing: '2.5px',

      textTransform: 'none',
    },
    navMobileLinkSmall: {
      color: 'text',
      fontFamily: 'body',
      lineHeight: 1,
      fontSize: 1,

      letterSpacing: '1.5px',

      textTransform: 'none',
    },
    signUpText: {
      fontWeight: '800',
      fontSize: '18px',
      lineHeight: '24px',
    },
    subNavText: {
      color: 'white',
      fontFamily: 'body',
      lineHeight: 1,
      fontSize: 0,
      letterSpacing: '1.5px',
      textTransform: 'uppercase',
    },
    navDropdownLink: {
      color: 'text',
      fontFamily: 'body',
      lineHeight: 1,
      cursor: 'pointer',
      fontSize: 2,
      fontWeight: 'normal',
      letterSpacing: 'normal',
      position: 'relative',
      my: '8px',
      '&:hover': {
        opacity: '.8',
      },
    },
    navDropdownBoldLink: {
      color: 'text',
      fontFamily: 'body',
      lineHeight: 1,
      my: '8px',
      fontSize: 2,
      fontWeight: 'semiBold',
      letterSpacing: 'normal',
      position: 'relative',
    },
    navDropdownHeader: {
      color: 'text',
      fontFamily: 'body',
      lineHeight: 1,
      my: '8px',
      fontSize: 2,
      fontWeight: 'semiBold',
      letterSpacing: 'normal',
      position: 'relative',
    },
    navDropdownHeaderLink: {
      color: 'text',
      fontFamily: 'body',
      lineHeight: 1,
      my: '8px',
      fontSize: 2,
      fontWeight: 'semiBold',
      letterSpacing: 'normal',
      position: 'relative',
      '&:hover': {
        opacity: '.8',
      },
    },
    textLink: {
      color: 'text',
      fontWeight: 'bold',
      fontHeight: 2,
      lineHeight: 2,
      letterSpacing: '4px',
      textDecorationLine: 'underline',
    },
    textLinkSmall: {
      fontWeight: '500',
      fontSize: 1,
      lineHeight: '16px',
      cursor: 'pointer',
      // textDecorationLine: 'underline',
    },
    textLinkLarge: {
      fontWeight: 'bold',
      fontSize: 4,
      lineHeight: '40px',
      letterSpacing: '4px',
      textDecorationLine: 'underline',
    },
    caption: {
      fontSize: 0,
      lineHeight: '16px',
      fontWeight: 'normal',
      letterSpacing: 'normal',
    },
    captionLarge: {
      fontSize: 1,
      lineHeight: '18px',
      fontWeight: 'normal',
      letterSpacing: '2px',
    },
    quotation: {
      fontStyle: 'italic',
      fontWeight: '900',
      fontSize: 3,
      lineHeight: 2,
      letterSpacing: 'normal',
    },
    buttonLabel: {
      fontWeight: 'bold',
      fontSize: [1],
      lineHeight: ['16px'],
      letterSpacing: '2px',
      textTransform: 'uppercase',
    },
    textSection: {
      fontSize: [2, null, 3],
      marginY: '1em',
      color: 'rgb(92, 92, 92)',
      fontWeight: 400,
      fontFamily: 'body',
      letterSpacing: '0.5px',
      lineHeight: ['25px', null, null, '30px'],
    },
    companyInfoText: {
      fontFamily: 'body',
      fontWeight: 'body',
      lineHeight: 0,
      fontSize: 0,
      color: 'text',
      letterSpacing: '0px',
    },
    footerColumnHeader: {
      fontFamily: 'body',
      lineHeight: '19.2px',
      letterSpacing: '1.5px',
      fontSize: [0, 1],
      color: 'text',
      fontWeight: 'semiBold',
    },
    footerColumnText: {
      color: 'body',
      fontFamily: 'body',
      lineHeight: 1,
      fontSize: [0, 1, 2],
      fontWeight: 'body',
      letterSpacing: '1px',
    },
    mediaTitle: {
      fontFamily: 'body',
      letterSpacing: '1.5px',
      lineHeight: '25.2px',
      fontSize: '18px',
      fontWeight: 'body',
    },
    iconBlockHeader: {
      fontFamily: 'body',
      fontWeight: 'bold',
      fontSize: [2, 2, 2, 18],
      letterSpacing: '2.5px',
      textTransform: 'uppercase',
    },
    miscLinkText: {
      fontFamily: 'body',
      fontWeight: 'body',
      fontSize: '11px',
      letterSpacing: '0.2px',
      lineHeight: '16.5px',
    },
    captionSemiBold: {
      letterSpacing: 'normal',
      fontSize: 0,
      lineHeight: '16px',
      fontWeight: 'semiBold',
    },
    captionBold: {
      letterSpacing: 'normal',
      fontSize: 0,
      lineHeight: '16px',
      fontWeight: 900,
    },
    description: {},
    blogTitle: {
      fontSize: 4,
      lineHeight: '24px',
      fontWeight: 900,
    },
    blogSubtitle: {
      fontSize: 2,
      lineHeight: '24px',
    },
    relatedPosts: {
      fontWeight: 900,
      fontSize: '36px',
      lineHeight: 3,
    },
    blogPostCategory: {
      fontSize: 4,
      lineHeight: '24px',
      fontWeight: 900,
      color: 'darkRed',
    },
    blogPostTitle: {
      fontSize: 6,
      fontHeight: '64px',
      fontWeight: 900,
    },
    blogPostText: {
      fontSize: 2,
      lineHeight: '24px',
      fontWeight: 400,
    },
    blogHeroTitle: {
      fontSize: 7,
      fontHeight: '64px',
      fontWeight: 900,
      color: 'white',
    },
    blogHeroText: {
      fontSize: 4,
      fontHeight: '24px',
      fontWeight: 400,
      color: 'white',
    },
    blogPostTitle2: {
      fontWeight: 900,
      lineHeight: '32px',
      fontSize: 4,
      color: 'white',
    },
  },
  alerts: {
    primary: {
      color: 'alert',
      bg: 'text',
      lineWeight: 'normal',
    },
    secondary: {
      color: 'alert',
      bg: 'text',
    },
    success: {
      color: 'alert',
      bg: 'success',
    },
    danger: {
      color: 'alert',
      bg: 'danger',
    },
  },
  forms: {
    label: {
      fontWeight: 'heading',
      fontSize: 1,
      lineHeight: '16px',
    },
    checkbox: {},
  },
  tag: {
    height: '24px',
    p: 2,
    bg: 'tag',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    display: 'inline-flex',
  },
  Black: {
    p: '3px 8px',
    bg: 'black',
    color: 'white',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    display: 'inline-flex',
    border: '1px solid black',
  },
  Outline: {
    p: '3px 8px',
    bg: 'white',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    display: 'inline-flex',
    border: '1px solid rgba(0, 0, 0, 0.2)',
  },
  accordion: {
    bg: 'background',
    borderTop: '1px solid #D1CDC5',
    borderBottom: '1px solid #D1CDC5',
    minHeight: '56px',
  },
  footerAccordion: {
    bg: 'background',
    minHeight: '56px',
    margin: '-3px',
    padding: '0px',
    borderTop: '2px solid black',
    borderBottom: '2px solid black',
  },
  footerBox: {
    flexDirection: 'column',
    justifyContent: ['flex-start'],
    alignItems: 'center',
    textAlign: ['center'],
    height: 'auto',
    letterSpacing: '1.5px',
    fontSize: 1,
  },
  productDropdown: {
    bg: 'lighterGray',
    p: '8px',
    pl: '15px',
  },
  productAccordion: {
    bg: 'background',
    margin: '-3px',
    padding: '0px',
    borderTop: '2px solid #EAE7E0',
    borderBottom: '2px solid #EAE7E0',
  },
  reviewForm: {
    bg: 'rgb(238, 238, 238);',
    p: '18px 20px 18px 20px',
  },
  questionForm: {
    bg: 'rgb(238, 238, 238);',
    p: '18px 20px 65px 20px',
  },
  modal: {
    fullScreen: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 1030,
      },
      content: {
        position: 'absolute',
        border: 'none',
        borderRadius: 0,
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        top: '0px',
        bottom: '0px',
        right: '0px',
        left: '0px',
        padding: '0px',
      },
    },
    small: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 1030,
      },
      content: {
        position: 'absolute',
        maxWidth: '500px',
        border: 'none',
        borderRadius: 0,
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        padding: '0px',
        top: '10vh',
        margin: 'auto',
        height: 'auto',
        bottom: 'auto',
      },
    },
    medium: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 1030,
      },
      content: {
        position: 'absolute',
        maxWidth: '900px',
        border: 'none',
        borderRadius: 0,
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        padding: '0px',
        top: '10vh',
        bottom: 'auto',
        margin: 'auto',
      },
    },
    large: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 1030,
      },
      content: {
        position: 'absolute',
        top: '40px',
        left: '40px',
        right: '40px',
        bottom: '40px',
        border: 'none',
        borderRadius: 0,
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        padding: '0px',
      },
    },
  },
}

export default theme
